import React, { useEffect, useState } from "react";
import "../../Styles/Pages/superadmin_dashboard.css";
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import instance from "../../utils/api";
import ReactApexChart from "react-apexcharts";
import Chart from "react-apexcharts";
import Topbar from "../../Layouts/Superadmin_layout/Superadmin_topbar";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const AllDetails = () => {
  const [dashboardData, setDashboardData] = useState();
  const [selectedYear, setSelectedYear] = useState(dayjs());
  const navigate = useNavigate();
  const { id } = useParams();

  const getAllData = async (year) => {
    try {
      const yearValue = dayjs.isDayjs(year) ? year.year() : year;
      const response = await instance.get(
        `dashboard/VendorDashboard?vendor_id=${id}&year=${yearValue}`
      );
      setDashboardData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllData(selectedYear);
  }, [selectedYear]);

  const handleYearChange = (date) => {
    setSelectedYear(date);
  };

  const options = {
    labels: ["Active", "Inactive"],
    colors: ["#19864A", "#F24E1E"],
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "50px",
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              fontSize: "16px",
              color: "#323232",
              fontWeight: "700",
              fontFamily: "Poppins",
              lineHeight: "21.78px",
            },
          },
        },
      },
    },
  };

  const chartOptions = {
    series: [
      {
        name: "Fields Count",
        data: dashboardData?.fields_month_counts,
        color: "#00A651",
      },
    ],
    options: {
      chart: {
        height: 500,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      yaxis: {
        title: {
          text: "Fields Count",
          // offsetX: -5, // Adjust horizontal offset for title positioning
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#333",
          },
        },
      },
      grid: {
        row: {
          colors: ["#FFFFFF", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      legend: {
        position: "right",
        offsetY: 7,
        height: 230,
      },
    },
  };

  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Topbar />
      {dashboardData ? (
        <section className="superadmin_header">
          <div className="back-to-vendors">
            <div className="overview">Overview Section</div>
            <div
              className="vendor-back-btn"
              onClick={() => navigate("/superadmin/Vendors")}
            >
              Back
            </div>
          </div>
          <div className="dasboard-container">
            <Card
              onClick={() =>
                navigate(
                  `/superadmin/StatusFieldOfficers/${id}?status=${"active"}`
                )
              }
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                height: "120px",
                cursor: "pointer",
              }}
            >
              <CardContent>
                <Typography className="text">Active Field Officers</Typography>
                <Typography className="text-value">
                  {dashboardData?.active_fieldofficers}
                </Typography>
              </CardContent>
            </Card>
            <Card
              onClick={() =>
                navigate(
                  `/superadmin/StatusFieldOfficers/${id}?status=${"inactive"}`
                )
              }
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                cursor: "pointer",
              }}
            >
              <CardContent>
                <Typography className="officer-text">
                  Inactive Field Officers
                </Typography>
                <Typography className="officer-text-value">
                  {dashboardData?.inactive_fieldofficers}
                </Typography>
              </CardContent>
            </Card>
            <Card
              onClick={() => navigate(`/superadmin/Fields/${id}`)}
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                height: "120px",
                cursor: "pointer",
              }}
            >
              <CardContent>
                <Typography className="records-text">Total Fields</Typography>
                <Typography className="records-text-value">
                  {dashboardData?.total_fields}
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
                <Typography className="officer-text" style={{ color: "#DE3163" }}>
                  Total Month Count
                </Typography>
                <Typography className="officer-text-value" style={{ color: "#DE3163" }}>
                  {/* {dashboardData?.total_month_count} */}0
                </Typography>
              </CardContent>
            </Card>
          </div>
          <div className="pie-chart-section">
            <div className="charts-section">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={5}>
                  <div className="piechart">
                    <Typography variant="h5">Field Officers Status</Typography>
                    <Chart
                      options={options}
                      series={[
                        dashboardData?.active_fieldofficers,
                        dashboardData?.inactive_fieldofficers,
                      ]}
                      type="donut"
                      height={200}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={7}>
                  <div className="wavechart">
                    <Typography variant="h5" className="linechart-header">
                      Fields Trend
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Year"
                          views={["year"]}
                          value={selectedYear}
                          onChange={handleYearChange}
                          sx={{
                            width: "100px",
                            "& .MuiInputBase-root": {
                              height: "40px",
                              fontSize: "14px",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Typography>
                    <ReactApexChart
                      options={chartOptions.options}
                      series={chartOptions.series}
                      type="line"
                      height={200}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </div>
  );
};

export default AllDetails;
